import { datadogRum } from "@datadog/browser-rum";
import type { Accounting } from "../api/engage/engage.types";
import type { ShellUser } from "../api/types";
import type { TrackEventPayloadWithOptionalPurposes } from "./createRudderstackEvent";
import {
  getBrowserName,
  getBrowserVersion,
  getDeviceType,
  getOSName,
  getOSVersion,
  getWindowDimension,
} from "./deviceInformation";
import type { ClientEvent } from "./eventTypes";

export const createClientEvent = (
  payload: TrackEventPayloadWithOptionalPurposes,
  user: ShellUser,
  accounting: Partial<Accounting>
): ClientEvent => {
  const sessionId = datadogRum.getInternalContext()?.session_id;
  if (!sessionId) {
    console.error("SessionId is not set");
  }
  return {
    eventInfo: {
      eventAction: payload.action || "",
      eventSessionId: sessionId || "",
      eventTag: payload.tag || "",
      eventTarget: "",
      eventTimestamp: Date.now(),
      eventTracingId: payload.id,
      eventType: payload.type || "com.sinch.onesaas.user_interaction",
      eventValue: "",
    },
    userInfo: {
      userAccountId: accounting.account_id || 0,
      userAccountName: accounting.company || "",
      userCountry: accounting.country || "",
      userId: user.id,
      userLanguage: user.language ?? "",
      userProjectId: user.activeProject || 0,
      userRoles: user.roles || [],
      userTier: "",
      userTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    deviceInfo: {
      deviceId: "",
      deviceType: getDeviceType(),
      deviceViewportSize: `${getWindowDimension().width}x${
        getWindowDimension().height
      }`,
      deviceOs: getOSName(),
      deviceOsVersion: getOSVersion(),
      deviceModel: "",
      deviceBrand: "",
      deviceBrowser: getBrowserName(),
      deviceBrowserVersion: getBrowserVersion(),
    },
    appInfo: {
      appName: "Engage",
      appMfe: payload.appName,
      appVersion: "",
      appDomain: window.location.hostname,
    },
    pageInfo: {
      pageUrl: payload.source,
      PrevPageURL: "",
    },
    experimentInfo: {
      experimentName: payload.experimentInfo?.experimentId || "",
      experimentBucket: payload.experimentInfo?.bucketId || "",
    },
    specificInfo: payload.customInfo || payload.specificInfo,
  };
};
